import cn from 'classnames';
import Lottie from 'lottie-react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useMediaQuery } from '@mui/material';

import { OTooltip } from '@src/shared';

import { useEmojiAnimations } from '@src/hooks';

import { BsEmojiLaughing } from 'react-icons/bs';

import { REACTIONS } from '@src/constants';

import { TEmojiId } from '@src/types';

import './styles.scss';

type EmojiReactionBarProps = {
  isDocumentPIP?: boolean;
  onSelect: (reactionId: TEmojiId) => void;
};

const EmojiReactionBar = ({ isDocumentPIP = false, onSelect }: EmojiReactionBarProps) => {
  const { animations, isEmojiPickerVisible, setIsEmojiPickerVisible } = useEmojiAnimations();
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <ClickAwayListener onClickAway={() => setIsEmojiPickerVisible(false)}>
      <div className="emoji-container">
        <OTooltip title={!isMobile && !isDocumentPIP ? 'Emojis' : ''}>
          <button
            type="button"
            className={`emoji-container__main-icon ${isEmojiPickerVisible ? 'active' : ''} ${isMobile ? 'mobile' : ''}`}
            onClick={(e: any) => {
              setIsEmojiPickerVisible((prev) => !prev);
              if (isMobile) {
                e.currentTarget.blur();
              }
            }}
          >
            <BsEmojiLaughing />
          </button>
        </OTooltip>
        {isEmojiPickerVisible && (
          <div
            className={cn('emoji-container__emoji-picker', {
              mobile: isMobile || isDocumentPIP,
              documentPIP: isDocumentPIP,
            })}
          >
            {REACTIONS.map((reaction) => (
              <button key={reaction} onClick={() => onSelect(reaction)} id={`footer-emoji__${reaction}`}>
                {animations[reaction] && <Lottie animationData={animations[reaction]} style={{ width: 26 }} />}
              </button>
            ))}
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default EmojiReactionBar;
